var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 11.25C18 13.7362 15.9862 15.75 13.5 15.75C11.0137 15.75 9 13.7362 9 11.25C9 8.76375 11.0137 6.75 13.5 6.75C15.9862 6.75 18 8.76375 18 11.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 27C20.9587 27 27 20.9587 27 13.5C27 6.04125 20.9587 0 13.5 0C6.04125 0 0 6.04125 0 13.5C0 20.9587 6.04125 27 13.5 27ZM20.5538 23.67C23.7712 21.4313 25.875 17.7188 25.875 13.5C25.875 6.66 20.34 1.125 13.5 1.125C6.66 1.125 1.125 6.66 1.125 13.5C1.125 17.7188 3.22875 21.4313 6.44625 23.67C7.23938 22.185 9.79875 18 13.5 18C17.2013 18 19.755 22.185 20.5538 23.67Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.30b397e73b2cef4fb4b9338522cf8dc3.svg";
export { ForwardRef as ReactComponent };